var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'base-status-badge',
    { 'enable-min-width': _vm.enableMinWidth && !_vm.icon, border: _vm.border },
    _vm.statusType,
    _vm.color ],attrs:{"data-external":_vm.dataExternal}},[(_vm.icon)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"icon-container"},[_c('BaseIcon',{staticClass:"icon",attrs:{"size":_vm.IconSize.Small,"icon":_vm.icon}})],1),_c('BaseH5',{staticClass:"text hidden-xs-and-down"},[_vm._v(_vm._s(_vm.text))])],1):_c('BaseH5',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }